export default __webpack_public_path__ + "img/eepkAaHy.54b9c159.svg";